var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menuItemsReady
    ? _c(
        "v-menu",
        {
          staticClass: "info-menu",
          attrs: {
            "open-on-hover": _vm.openOnHover,
            "open-on-click": !_vm.openOnHover,
            "nudge-top": "10",
            "offset-y": "",
            attach: "body"
          }
        },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "smart-tooltip",
                  rawName: "v-smart-tooltip",
                  value: {
                    show: _vm.showSettingsTooltip,
                    text: _vm.$t("floatingTopMenu.settingsTooltip"),
                    position: "bottom",
                    dark: true,
                    showOnce: true,
                    name: "settingsTooltip"
                  },
                  expression:
                    "{show: showSettingsTooltip, text: $t('floatingTopMenu.settingsTooltip'), position: 'bottom', dark: true, showOnce: true, name: 'settingsTooltip'}"
                }
              ],
              staticClass: "no-padding pl2 pr2",
              attrs: { slot: "activator", flat: "" },
              on: { click: _vm.menuClicked },
              slot: "activator"
            },
            [
              _c("v-icon", [
                _vm._v(_vm._s(_vm.showSettings ? "more_vert" : "info"))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm._l(_vm.menuItems, function(item, index) {
                return [
                  item.show
                    ? _c(
                        "v-layout",
                        { key: index, attrs: { row: "" } },
                        [
                          item.emitEvent
                            ? _c(
                                "v-btn",
                                {
                                  key: index,
                                  staticClass: "floating-item",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.emitEvent(item.emitEvent)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        title: item.title,
                                        left: "",
                                        color: "dark"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.icon))]
                                  ),
                                  _vm._v(" "),
                                  [_vm._v(_vm._s(item.title))]
                                ],
                                2
                              )
                            : _c(
                                "v-btn",
                                {
                                  key: index,
                                  staticClass: "floating-item",
                                  attrs: {
                                    flat: "",
                                    target: item.target,
                                    href: item.href
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        title: item.title,
                                        left: "",
                                        color: "dark"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.icon))]
                                  ),
                                  _vm._v(" "),
                                  [_vm._v(_vm._s(item.title))]
                                ],
                                2
                              )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024e9dc0", { render: render, staticRenderFns: staticRenderFns })
  }
}